import { LOCALE_REGEXP } from '@finder/shared/constants/app.constants';

/**
 * @param url - relative URL, possibly including a locale (xx-xx or xx_XX)
 * @returns string - the URL, now stripped of its locale if it was present
 */
function stripLocaleFromUrl(
    url: string,
): string {
    const pieces = url.split('/').filter(Boolean);

    if (pieces[0].match(LOCALE_REGEXP.lacd)) {
        const locale = pieces.shift();
    }
    // If the url ends with a slash, we are adding it back to the return value
    const endSlash = url.slice(-1) === '/' ? '/' : '';

    return `/${pieces.join('/') + endSlash}`;
}

export default stripLocaleFromUrl;
